import "../../../FhDropdownMenu.css";
import { useSlots, ref, computed, provide, reactive, openBlock, createBlock, withCtx, resolveDynamicComponent, withKeys, withModifiers, createElementVNode, mergeProps, renderSlot, nextTick } from "vue";
import { o as offset, f as flip, F as FhOverlay } from "../../../FhOverlay-Cm2BKH3f.js";
import useGetFirstElement from "../../composables/useGetFirstElement.mjs";
import { DropdownContextKey } from "../Symbols.mjs";
import { beaconToken } from "../../utils.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhDropdownMenu",
  setup(__props, { expose: __expose }) {
    const slots = useSlots();
    const invokerRef = useGetFirstElement();
    const overlayRef = ref(null);
    const dropdownListRef = ref(null);
    const activeIndex = ref(-1);
    const floatingOptions = {
      middleware: [
        offset(beaconToken("--fh-space-xs").unitless),
        flip({
          fallbackPlacements: ["bottom-end"]
        })
      ],
      placement: "bottom-start"
    };
    const computedDefaultSlotVNode = computed(() => {
      var _a, _b;
      return {
        ...(_b = (_a = slots.default) == null ? void 0 : _a.call(slots)) == null ? void 0 : _b[0]
      };
    });
    const computedDropdownIcon = computed(
      () => {
        var _a, _b, _c, _d;
        return ((_b = (_a = computedDefaultSlotVNode == null ? void 0 : computedDefaultSlotVNode.value) == null ? void 0 : _a.props) == null ? void 0 : _b.dropdown) !== void 0 || // eslint-disable-next-line no-underscore-dangle
        ((_d = (_c = computedDefaultSlotVNode == null ? void 0 : computedDefaultSlotVNode.value) == null ? void 0 : _c.type) == null ? void 0 : _d.__name) === "FhButton";
      }
    );
    const getFocusableItems = () => dropdownListRef.value.querySelectorAll(".fh-dropdown-focusable");
    const focusItem = (index = null) => {
      const items = getFocusableItems();
      let targetIndex = index;
      if (targetIndex === null) {
        targetIndex = Array.from(items).findIndex(
          (item) => item.getAttribute("aria-selected") === "true"
        );
        if (targetIndex === -1) {
          targetIndex = 0;
        }
      }
      if (targetIndex >= 0 && targetIndex < items.length) {
        items[targetIndex].focus();
        activeIndex.value = targetIndex;
      }
    };
    const handleInvokerKeydown = (event) => {
      var _a, _b;
      switch (event.key) {
        case "ArrowDown":
        case "ArrowUp":
          event.preventDefault();
          if (!((_a = overlayRef.value) == null ? void 0 : _a.isOpen)) {
            (_b = overlayRef.value) == null ? void 0 : _b.open();
            nextTick(() => focusItem());
          } else {
            nextTick(() => focusItem());
          }
          break;
      }
    };
    const toggleDropdown = (event) => {
      var _a, _b, _c;
      if ((_a = overlayRef.value) == null ? void 0 : _a.isOpen) {
        (_b = overlayRef.value) == null ? void 0 : _b.close();
      } else {
        (_c = overlayRef.value) == null ? void 0 : _c.open();
        if ((event == null ? void 0 : event.type) === "keydown") {
          nextTick(() => focusItem());
        }
      }
    };
    const handleDropdownKeydown = (event) => {
      var _a;
      const items = getFocusableItems();
      switch (event.key) {
        case "ArrowDown":
          focusItem((activeIndex.value + 1) % items.length);
          event.preventDefault();
          break;
        case "ArrowUp":
          focusItem((activeIndex.value - 1 + items.length) % items.length);
          event.preventDefault();
          break;
        case "Home":
          focusItem(0);
          event.preventDefault();
          break;
        case "End":
          focusItem(items.length - 1);
          event.preventDefault();
          break;
        case "Tab":
          (_a = overlayRef.value) == null ? void 0 : _a.close();
          invokerRef.value.focus();
          event.preventDefault();
          break;
      }
    };
    const handleItemSelected = (event) => {
      nextTick(() => {
        var _a;
        (_a = overlayRef.value) == null ? void 0 : _a.close();
        if ((event == null ? void 0 : event.type) === "keydown") {
          invokerRef.value.focus();
        }
      });
    };
    provide(
      DropdownContextKey,
      reactive({
        selected: handleItemSelected
      })
    );
    const close = () => {
      var _a;
      (_a = overlayRef.value) == null ? void 0 : _a.close();
    };
    __expose({
      close
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(FhOverlay, {
        role: "menu",
        "floating-options": floatingOptions,
        "close-on-click-outside": "",
        ref_key: "overlayRef",
        ref: overlayRef
      }, {
        invoker: withCtx(() => {
          var _a, _b;
          return [
            (openBlock(), createBlock(resolveDynamicComponent(computedDefaultSlotVNode.value), {
              dropdown: computedDropdownIcon.value,
              selected: (_a = overlayRef.value) == null ? void 0 : _a.isOpen,
              "aria-expanded": (_b = overlayRef.value) == null ? void 0 : _b.isOpen,
              onClick: toggleDropdown,
              onKeydown: [
                withKeys(withModifiers(toggleDropdown, ["prevent"]), ["enter", "space"]),
                handleInvokerKeydown
              ]
            }, null, 40, ["dropdown", "selected", "aria-expanded", "onKeydown"]))
          ];
        }),
        default: withCtx(() => [
          createElementVNode("ul", mergeProps({
            class: "fh-dropdown-list",
            ref_key: "dropdownListRef",
            ref: dropdownListRef,
            onKeydown: handleDropdownKeydown
          }, _ctx.$attrs), [
            renderSlot(_ctx.$slots, "sections", {}, void 0, true)
          ], 16)
        ]),
        _: 3
      }, 512);
    };
  }
});
const FhDropdownMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-37260636"]]);
export {
  FhDropdownMenu as default
};
//# sourceMappingURL=FhDropdownMenu.mjs.map
